import React from "react";

import { format, parse } from "date-fns";

import { formatBalance } from "../PerformanceGroups/Shared/helpers";
import Text from "@src/sharedComponents/Typography/Text";

import styles from "./GraphTooltip.module.css";

interface TooltipPayloadValueDataKey {
  value: number;
}

interface TooltipPayloadRangeDataKey {
  value: [number, number];
}

interface TooltipPayload {
  0: TooltipPayloadValueDataKey;
  1: TooltipPayloadRangeDataKey;
}

interface TooltipProps {
  active: boolean;
  label: string; // yyyy-MM-dd
  payload: TooltipPayload;
}

const isTooltipProps = (
  ttProps: TooltipProps | any
): ttProps is TooltipProps => {
  return (
    ttProps.active &&
    ttProps.payload &&
    "0" in ttProps.payload &&
    "1" in ttProps.payload
  );
};

interface Props {
  props: any;
}

const FinancialPlansProjectionGraphTooltip = ({ props: ttProps }: Props) => {
  if (isTooltipProps(ttProps)) {
    const value = ttProps.payload["0"].value;
    const [low, high] = ttProps.payload["1"].value;

    return (
      <div className={styles.graphTooltip}>
        <div className={styles.flexBetween}>
          <Text variant="body" color="text">
            Net Worth
          </Text>

          <Text variant="body" color="text">
            {format(parse(ttProps.label, "yyyy-MM-dd", new Date()), "M/yyyy")}
          </Text>
        </div>

        <div className={styles.flexBetween}>
          <Text variant="body" color="text">
            Median
          </Text>

          <Text variant="body" color="text">
            {formatBalance(value)}
          </Text>
        </div>

        <div className={styles.flexBetween}>
          <Text variant="body" color="textSubtle">
            Low
          </Text>

          <Text variant="body" color="textSubtle">
            {formatBalance(low)}
          </Text>
        </div>

        <div className={styles.flexBetween}>
          <Text variant="body" color="textSubtle">
            High
          </Text>

          <Text variant="body" color="textSubtle">
            {formatBalance(high)}
          </Text>
        </div>
      </div>
    );
  }

  return <></>;
};

export default FinancialPlansProjectionGraphTooltip;
